module.exports = __webpack_public_path__ + "img/check_simple.4e1504a5.svg";